import styled from 'styled-components';

export const DashboardMenuContainer = styled.div.attrs({})`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
`;

export const DashboardMenu = styled.div.attrs({ className: 'menu-contant' })`
  width: 276px;
  background: ${(props) => props.theme.palette.colors.white};
  min-height: 100vh;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-bottom: 24px;
  &::-webkit-scrollbar {
    width: 0px;
  }
  // &::-webkit-scrollbar { width: 4px; }
  // &::-webkit-scrollbar-thumb { background: #cccccc; border-radius: 10px; }
`;

export const DashboardMenuHeader = styled.div.attrs({})`
  height: 80px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  color: ${(props) => props.theme.palette.colors.white};
  background: ${(props) => props.theme.palette.colors.white};
`;

export const DashboardMenuHeaderIcon = styled.img.attrs({})`
  margin-right: 20px;
  cursor: pointer;
`;

export const DashboardMenuHeaderUserContent = styled.div.attrs({})`
  padding: 27px 25px;
  margin-bottom: 28px;
  background: ${(props) => props.theme.palette.primary.main};
`;

export const DashboardMenuHeaderUserImage = styled.div.attrs({})`
  width: 160px;
  height: 160px;
  border-radius: 80px;
  background: ${(props) => props.theme.palette.colors.grey} url(/logo1024.png)
    no-repeat center center / cover;
  margin: 0 auto 12px;
  overflow: hidden;
`;

export const DashboardMenuHeaderUserText = styled.div.attrs({})`
  font-size: 15px;
  font-weight: bold;
  color: ${(props) => props.theme.palette.colors.grey};
  margin-bottom: 12px;
`;

export const OptionsContainer = styled.div.attrs({})`
  display: flex;
  gap: 4px;
  align-items: center;
  padding: 11px;
  color: ${(props) => props.theme.palette.colors.black};
  cursor: pointer;
  border-radius: 4px;
  font-family: Kumbh Sans;
  font-size: 15px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  justify-content: space-between;
  ${(props) =>
    props.active
      ? `
            background: ${props.theme.palette.gradient.primary};
            font-size: 15px;
            font-weight: bold;
            color: ${props.theme.palette.colors.white};
        `
      : ``}
`;

export const ArrowWrapper = styled.div.attrs({})`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease-in-out;
  transform: ${(props) => (props.$isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

export const DashboardMenuOption = styled.div.attrs({})`
  padding: 4px 0;
  border-bottom: 1px solid ${(props) => props.theme.palette.colors.shadow};
  ${(p) => (p.last ? `border-bottom: none;` : ``)}
`;

export const DashboardMenuContent = styled.div.attrs({})`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  overflow-y: auto;
  gap: 12px;
  opacity: ${(props) => (props.$ready ? 1 : 0)};
  pointer-events: ${(props) => (props.$ready ? 'auto' : 'none')};
  transition: opacity 1.3s ease;
`;

export const DashboardMenuFooterContainer = styled.div.attrs({})`
  flex-shrink: 0;
  margin-top: auto;
  padding: 16px;
  padding-bottom: 4px;
  background: ${(props) => props.theme.palette.colors.white};
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const DashboardMenuFooter = styled.div.attrs({})`
  font-family: Kumbh Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  height: 40px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  cursor: pointer;
`;

export const DashboardVersionContent = styled.div.attrs({})`
  margin: 24px 0;
`;

export const DashboardVersionText = styled.div.attrs({})`
  font-size: 15px;
  font-weight: bold;
  color: ${(props) => props.theme.palette.colors.grey};
  text-align: center;
`;

export const HeaderItemIconBadge = styled.div.attrs({})`
  min-width: 24px;
  max-width: 24px;
  height: 24px;
  border-radius: 24px;
  background: ${(props) => props.theme.palette.gradient.primary};
  color: ${(props) => props.theme.palette.white.main};
  font-family: Kumbh Sans;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SubMenuItem = styled.div.attrs({})`
  font-family: Kumbh Sans;
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  color: ${(props) => props.theme.palette.colors.grey};
  padding: 4px 14px;
  cursor: pointer;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 32px;
  ${(props) =>
    props.active
      ? `font-weight: bold; color: ${props.theme.palette.colors.black};`
      : ``}
`;

export const SideContent = styled.div.attrs({})``;

export const SideOptionContent = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SideUserItemImage = styled.div.attrs({})`
  min-width: 48px;
  height: 48px;
  background: url(${(p) => p.url}) no-repeat center center / cover;
  overflow: hidden;
  border-radius: 4px;
`;

export const SideUserItemTitle = styled.div.attrs({})`
  font-family: Kumbh Sans;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: ${(p) => p.theme.palette.colors.black};
`;

export const SideUserItemText = styled.div.attrs({})`
  font-family: Kumbh Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: ${(p) => p.theme.palette.colors.black};
  display: flex;
  align-items: center;
`;
